// ── LT-2 — the two app-wide banners ──────────────────────────────────────────
// Rendered above every page from MsquaredApp.
//
// ⚠️ THE READ-ONLY BANNER IS AN EXPLANATION, NOT A CONTROL. The Save and New
// buttons still render and still submit; the SERVER refuses them. That is
// deliberate: hiding the buttons would make a lapsed account look broken, and
// would put the decision in the browser where it can be bypassed. The banner
// exists so the refusal is never mysterious — a customer who clicks Save and
// sees an error deserves to already know why.
import { C } from "../customers/theme";

const wrap = (bg, border) => ({
  display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap",
  background: bg, border: `1px solid ${border}`, borderRadius: 8,
  padding: "10px 16px", marginBottom: 16, fontSize: 13.5, color: C.text, lineHeight: 1.5,
});
const link = {
  background: "none", border: "none", padding: 0, color: C.primary,
  font: "inherit", fontWeight: 700, cursor: "pointer", textDecoration: "underline",
};

/** Shown from 15 days out. Earlier than that it is noise on every screen. */
export function TrialBanner({ daysLeft, onSubscribe }) {
  if (typeof daysLeft !== "number" || daysLeft > 15) return null;
  return (
    <div role="status" style={wrap("#2b2410", C.warning)}>
      <span aria-hidden="true">⏳</span>
      <div style={{ flex: 1, minWidth: 220 }}>
        {daysLeft <= 0
          ? "Your free trial ends today."
          : `${daysLeft} ${daysLeft === 1 ? "day" : "days"} left on your free trial.`}{" "}
        Subscribe to keep adding new work — everything you've already entered stays either way.
      </div>
      <button style={link} onClick={onSubscribe}>Subscribe</button>
    </div>
  );
}

export function ReadOnlyBanner({ onSubscribe }) {
  return (
    <div role="status" style={wrap(C.dangerDim, C.danger)}>
      <span aria-hidden="true">🔒</span>
      <div style={{ flex: 1, minWidth: 220 }}>
        <strong>Read-only.</strong> Your trial has ended, so new invoices, expenses and edits are paused.
        Nothing has been deleted — you can still open, print and export everything.
      </div>
      <button style={link} onClick={onSubscribe}>Subscribe</button>
    </div>
  );
}
